import { render, staticRenderFns } from "./InvoiceFiltersForm.vue?vue&type=template&id=70736c3c&"
import script from "./InvoiceFiltersForm.vue?vue&type=script&lang=ts&"
export * from "./InvoiceFiltersForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports